export const apiUrl =
  "https://api.teamtailor.com/v1/jobs?page%5Bsize%5D=30&include=department"
export const headers = {
  Authorization: "Token token=Qh7maZcNKFBOFk0ALK9yjRUsayXn3DXvQx-YfFuP",
  "X-Api-version": "20161108",
  Accept: "*/*",
}
